import React, { FC } from 'react';
import styles from './StatusLabel.module.sass';
import ToolTip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

interface PropTypes {
    status: string;
}

export const StatusLabel: FC<PropTypes> = ({ status }) => <OverlayTrigger
    key={`overlay-status`}
    placement="top"
    overlay={<ToolTip
        className="text-capitalize"
        id="button-tooltip">{status}</ToolTip>}>
    <span className={`${styles.status} ${status}`}><i
        className={`fas fa-circle ${styles.statusIcon}`} /></span>
</OverlayTrigger>;
